import { Link } from 'react-router-dom'
import { FiClock, FiCalendar, FiStar, FiMapPin } from 'react-icons/fi'
import { getImageUrl } from '../utils/imageUrl'
import { getCategoryColor, getCategoryLabel } from '../helpers/category'

export default function EventCard({ event }) {

    const currentLanguage = localStorage.getItem('app_lang')

    return (
        <Link
            to={`/events/${event.slug}`}
            className="card flex flex-col h-full group overflow-hidden hover:border-primary-500/50 transition-all duration-300 hover:shadow-2xl hover:shadow-primary-500/10"
        >
            {/* Image */}
            <div className="relative h-48 overflow-hidden">
                {event.image_url ? (
                    <img
                        src={event.image_url.startsWith('http') ? event.image_url : `${import.meta.env.VITE_API_URL?.replace('/api', '') || 'http://localhost:8000'}${event.image_url}`}
                        alt={event.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                ) : (
                    <div className={`w-full h-full bg-gradient-to-br ${getCategoryColor(event.category)} opacity-50`} />
                )}

                {/* Category Badge */}
                <div className={`absolute top-3 left-3 px-3 py-1 rounded-full text-xs font-medium text-gray-900 bg-gradient-to-r ${getCategoryColor(event.category)}`}>
                    {getCategoryLabel(event.category)}
                </div>

                {/* 
                {event.is_featured && (
                    <div className="absolute top-3 right-3 px-3 py-1 rounded-full text-xs font-medium text-yellow-400 bg-gray-900/80 flex items-center gap-1">
                        <FiStar className="w-3 h-3" />
                        {window.t('preporachano')}
                    </div>
                )}
                */}

                {/* Gradient Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-transparent to-transparent" />
            </div>

            {/* Content */}
            <div className="p-5 flex flex-col flex-1">
                <h3 className="text-lg font-semibold text-white group-hover:text-primary-400 transition-colors line-clamp-1">
                    {currentLanguage === 'en' ? (event.title_en || event.title) : event.title}
                </h3>

                {(currentLanguage === 'en' ? (event.description_en || event.description) : event.description) && (
                    <p className="text-gray-400 text-sm mt-2 line-clamp-2">
                        {currentLanguage === 'en' ? (event.description_en || event.description) : event.description}
                    </p>
                )}

                <div className="flex flex-wrap items-center gap-4 mt-4 mb-4 text-sm text-gray-500">
                    {event.hall && (
                        <div className="flex items-center gap-1 w-full text-gray-400 mb-1">
                            <FiMapPin className="w-4 h-4 text-primary-500" />
                            {currentLanguage === 'en' ? (event.hall.name_en || event.hall.name) : event.hall.name}
                        </div>
                    )}
                    {event.duration_minutes && (
                        <div className="flex items-center gap-1">
                            <FiClock className="w-4 h-4" />
                            {event.duration_minutes} {window.t('min')}
                        </div>
                    )}
                    {event.performances_count > 0 && (
                        <div className="flex items-center gap-1">
                            <FiCalendar className="w-4 h-4" />
                            {event.performances_count} {window.t('dati')}
                        </div>
                    )}
                    {event.age_restriction && (
                        <div className="px-2 py-0.5 rounded bg-gray-800 text-gray-400 text-xs">
                            {event.age_restriction}
                        </div>
                    )}
                </div>

                {event.min_price && (
                    <div className="mt-auto pt-4 border-t border-gray-800">
                        <span className="text-gray-500 text-sm">{window.t('ot')} </span>
                        <span className="text-white font-bold text-lg">€{event.min_price}</span>
                    </div>
                )}
            </div>
        </Link>
    )
}
